import client from '../../../apis/client'
import { AxiosPromise } from 'axios'

/**
 * フォーマット設定（医療機関の様式）の API。**annotator latest の面で唯一の書き込み。**
 *
 * 読むのは機関（`hospitals/<10桁コード>/format-setting/`）、書くのは紙
 * （`prescriptions/<uuid>/format-annotations/` に 1 行追記）。様式は医療機関の属性で、
 * request は「それを見て判断した紙」なので、資源が別。
 *
 * 語彙（項目・選択肢）は backend の format_mapping が持ち、ここは items[] をそのまま描く。
 * front に選択肢の定数を置かないこと — Excel のチェックシートと同じ表から出ている。
 */

export type FormatSettingItem = {
  key: string
  label: string
  /** 画面の見出し（表記 / 保険欄）。front は key を知らずにこれで束ねる */
  group: string
  choices: string[]
  /** hospital_setting.json の現行値。逆引きできない（判断済みでも json から読めない）ときは null */
  current: string | null
  /** 編集ログ（機関の最新行）の値。無ければ null */
  draft: string | null
}

export type LatestFormatAnnotation = {
  id: string
  ocr_request_event_id: string
  created_at: string
  annotated_by_email: string
}

export type HospitalFormatSetting = {
  full_hospital_code: string
  hospital_name: string
  is_format_annotated: boolean
  is_insurance_layout_declared: boolean
  items: FormatSettingItem[]
  memo: string
  latest_annotation: LatestFormatAnnotation | null
}

export type FormatAnnotationInput = {
  values: Record<string, string | null>
  memo: string
}

export type FormatAnnotation = {
  id: string
  ocr_request_event_id: string
  full_hospital_code: string
  hospital_name: string
  values: Record<string, string>
  memo: string
  annotated_by_email: string
  created_at: string
}

export const getHospitalFormatSetting = (
  fullHospitalCode: string
): AxiosPromise<HospitalFormatSetting> =>
  client.get(`api/annotator/hospitals/${fullHospitalCode}/format-setting/`)

/** この紙で下した判断を 1 行足す（追記のみ）。機関コードは backend が basic_result から決める。 */
export const postFormatAnnotation = (
  ocrRequestEventId: string,
  body: FormatAnnotationInput
): AxiosPromise<FormatAnnotation> =>
  client.post(
    `api/annotator/prescriptions/${ocrRequestEventId}/format-annotations/`,
    body
  )
